import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { Grid, Collapse, Tooltip, FormControlLabel, Switch, Checkbox } from '@material-ui/core';

import TableItem from '../TableItem';
import SpecialTable from '../SpecialTable';
import Covenant from '../Covenant';
import ModalConfirmation from '../../../../components/ModalConfirmation';
import Modal from '../../../../components/Modal';
import Button from '../../../../components/Button';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faHandshake, faChevronDown, faChevronUp, faLock, faLockOpen } from '@fortawesome/free-solid-svg-icons';

import { Edit, Delete } from '@material-ui/icons';

import { handleCovenant, handleUpdate, handleRemoveAndReplaceModalOpen, setRemoveAndReplaceTable, openSpecialForm, setLinkedTableName } from '../../store/actions';
import { loadCovenant, changeTableProp, removeTable } from '../../store/thunk';

import { convertToReal, convertMinutesToPeriod } from '../../../../helpers/converters';
import useWindowDimensions from 'helpers/hooks/useWindowDimensions';

import { useStyles } from '../styles';

export default function Table({ data }) {
  const dispatch = useDispatch();

  const classes = useStyles();

  const { width } = useWindowDimensions();
  const isMobile = width < 960;

  const [isOpen, openTable] = useState(false);

  const [isSettingTableInsivible, setIsSettingTableInsivible] = useState(false);
  const [isTableInvisible, setIsTableInvisible] = useState(false);

  const [isRemoving, handleRemoveTable] = useState(false);

  const { name, typePrice, major, items, covenant, invisible, tolerance, maximumPeriod, maximumValue, specialPrices } = data;

  const { userId } = useSelector(state => state.profile);
  const { establishmentId } = useSelector(state => state.businessInfo);
  const { isLoading, isSpecial, isCovenant } = useSelector(state => state.priceTable);

  const timeRanges = items
    ?.filter(item => +item?.since == 0)
    ?.sort((a, b) => b.period - a.period)
    ?.reverse();

  const specificTimeRanges = items
    ?.filter(item => +item?.since > 0)
    ?.sort((a, b) => b.since - a.since)
    ?.reverse();

  const handleRemoveConfirmation = () => {
    dispatch(setRemoveAndReplaceTable(typePrice));

    dispatch(removeTable(userId, establishmentId, typePrice)).catch(error => {
      if(error == '0937') {
        dispatch(handleRemoveAndReplaceModalOpen(true));
      }
    });
  }

  const handleUpdateTable = event => {
    if(isMobile) {
      const priceTableFormTop = window.document.getElementById('price-table-form').offsetTop;
      window.scrollTo({ top: priceTableFormTop - 10, behavior: 'smooth' });
    }

    dispatch(openSpecialForm(false, ''));
    dispatch(setLinkedTableName(''));
    dispatch(handleUpdate(data));
    event.preventDefault();
  }

  const handleChangeTableProp = e => {
    const params = {
      invisible: invisible ? 0 : 1
    }

    dispatch(changeTableProp(userId, establishmentId, params, typePrice));
    setIsSettingTableInsivible(false);
  }

  const handleMainTable = () => {
    const params = {
      major: major ? 0 : 1
    }

    dispatch(changeTableProp(userId, establishmentId, params, typePrice));
  }

  const handleCovenantModal = () => {
    dispatch(loadCovenant(userId, establishmentId, typePrice)).then(res => {
      if(!res) {
        return dispatch(handleCovenant(true, typePrice, false));
      }

      dispatch(handleCovenant(true, typePrice, true));
    });
  }

  const handleSpecialTableForm = e => {
    const { checked } = e.target;

    dispatch(openSpecialForm(checked, typePrice));
    dispatch(setLinkedTableName(name));
  }

  return(
    <Grid className={classes.root}>
      <Grid container justify="space-between" alignItems="center">
        <Grid item>
          <Button
            disableElevation
            color="transparent"
            className={classes.title}
            onClick={() => openTable(!isOpen)}
          >
            {name}
          </Button>
        </Grid>
        <Grid item>
          <Tooltip arrow placement="bottom" title="Editar" enterTouchDelay={0}>
            <Button
              disableElevation
              type="button"
              color="transparent"
              onClick={event => handleUpdateTable(event)}
            >
              <Edit style={{ color: '#2CA9D6' }} />
            </Button>
          </Tooltip>
          <Tooltip arrow placement="bottom" title="Remover" enterTouchDelay={0}>
            <Button
              disableElevation
              type="button"
              color="transparent"
              onClick={() => handleRemoveTable(true)}
            >
              <Delete style={{ color: '#F66C6B' }} />
            </Button>
          </Tooltip>
          <Tooltip arrow placement="bottom" title="Torna principal" enterTouchDelay={0}>
            <Button
              disableElevation
              type="button"
              id="major"
              color="transparent"
              onClick={handleMainTable}
            >
              <FontAwesomeIcon
                icon={major ? faLock : faLockOpen}
                color="#52BC76"
              />
            </Button>
          </Tooltip>
          <Tooltip
            arrow
            placement="bottom"
            title={covenant ? "O convênio está ativo" : "Ativar convênio"}
            enterTouchDelay={0}
          >
            <Button
              disableElevation
              type="button"
              color="transparent"
              onClick={handleCovenantModal}
            >
              <FontAwesomeIcon
                icon={faHandshake}
                color={covenant ? "#FDC02F" : "#C2C2C2"}
              />
            </Button>
          </Tooltip>
          <Tooltip
            arrow
            placement="bottom"
            title={invisible ? 'Tabela está invisível' : 'Tabela está visível'}
            enterTouchDelay={0}
          >
            <Button
              disableElevation
              type="button"
              id="invisible"
              color="transparent"
              onClick={() => invisible ? handleChangeTableProp() : setIsSettingTableInsivible(true)}
            >
              <FontAwesomeIcon
                icon={invisible ? faEyeSlash : faEye}
                color="#022A5C"
              />
            </Button>
          </Tooltip>
          <Button
            disableElevation
            type="button"
            color="transparent"
            onClick={() => openTable(!isOpen)}
          >
            <FontAwesomeIcon
              icon={isOpen ? faChevronUp : faChevronDown}
              color="#757575"
            />
          </Button>
        </Grid>
      </Grid>
      {isSettingTableInsivible && (
        <Modal
          title='Tabela invisível'
          open={isSettingTableInsivible}
          onClose={() => setIsSettingTableInsivible(false)}
        >
          <Grid container>
            <Grid xs={12} style={{ margin: '10px 0 10px 0' }}>
              Ao tornar a tabela invisível, ela não poderá ser selecionada no aplicativo operacinal.
            </Grid>
            <Grid xs={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    name='prePaidExit'
                    type='checkbox'
                    checked={isTableInvisible}
                    onChange={e => setIsTableInvisible(e.target.checked)}
                  />
                }
                label='Deixar tabela invisível'
              />
            </Grid>
            <Grid xs={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                type='submit'
                color='success'
                disabled={!isTableInvisible}
                onClick={handleChangeTableProp}
              >
                Salvar
              </Button>
            </Grid>
          </Grid>
        </Modal>
      )}
      <ModalConfirmation
        open={isRemoving}
        isLoading={isLoading}
        onClose={() => handleRemoveTable(false)}
        handleConfirmation={handleRemoveConfirmation}
      >
        Não remova se tiver com alguma Ordem de serviço no pátio. Haverá problema de cobrança. Troque a tabela no aplicativo antes de remover.
      </ModalConfirmation>
      <Covenant isOpen={isCovenant} />
      <Collapse in={isOpen}>
        <Grid container>
          {tolerance !== 0 && (
            <Grid xs={12}>
              <TableItem
                value={`Tolerancia inicial de ${convertMinutesToPeriod(tolerance)}`}
              />
            </Grid>
          )}
          {timeRanges?.length > 0 && (
            timeRanges?.map((timeRange, index) => {
              return(
                <Grid key={index} xs={12}>
                  <TableItem
                    value={`Até ${convertMinutesToPeriod(timeRange.period)} cobrar o valor de ${convertToReal(timeRange.price)}`}
                  />
                </Grid>
              )
            })
          )}
          {specificTimeRanges?.length > 0 && (
            specificTimeRanges?.map((timeRange, index) => {
              return(
                <Grid key={index} xs={12}>
                  <TableItem
                    value={`A partir de ${convertMinutesToPeriod(timeRange.since)} a cada ${convertMinutesToPeriod(timeRange.period)} somar ${convertToReal(timeRange.price)}`}
                  />
                </Grid>
              )
            })
          )}
          {maximumPeriod !== 0 && (
            <Grid xs={12}>
              <TableItem
                value={`Até o período de ${convertMinutesToPeriod(maximumPeriod)} cobrar o valor máximo de ${convertToReal(maximumValue)}`}
              />
            </Grid>
          )}
        </Grid>
        {specialPrices && specialPrices.map(specialPrice => (
          <SpecialTable data={specialPrice} />
        ))}
        <Grid container justify="flex-end">
          <FormControlLabel
            value="start"
            labelPlacement="start"
            label="Deseja adicionar uma condição especial a essa tabela?"
            className={classes.title}
            control={
              <Switch
                color="primary"
                onChange={handleSpecialTableForm}
                checked={isSpecial.includes(typePrice)}
              />
            }
          />
        </Grid>
      </Collapse>
    </Grid>
  );
}

Table.propTypes = {
  data: PropTypes.shape({
    typePrice: PropTypes.string,
    major: PropTypes.bool,
    covenant: PropTypes.bool,
    invisible: PropTypes.bool,
    tolerance: PropTypes.number,
    items: PropTypes.string,
    maximumPeriod: PropTypes.string,
    maximumValue: PropTypes.string,
    specialPrices: PropTypes.arrayOf(PropTypes.shape())
  })
};

Table.defaultProps = {
  data: {
    typePrice: '',
    major: false,
    covenant: false,
    invisible: false,
    tolerance: '',
    items: [],
    maximumPeriod: '',
    maximumValue: '',
    specialPrices: []
  }
};